import { useSite } from "@/contexts/SiteContext";
import TreeSvg from "@/components/garden/TreeSvg";

/*
 * Afișarea copacului. Dacă adminul a încărcat imagini reale (foto-realiste) per stadiu
 * în Setări → Copacul (settings.tree_images.stage_1..7), le folosim. Altfel, fallback la
 * ilustrația SVG. Astfel realismul intră instant când imaginile există, fără schimbări de cod.
 */
export function treeImageUrl(site, stage) {
  return site?.tree_images?.[`stage_${stage}`] || "";
}

function RainOverlay({ size }) {
  return (
    <svg className="absolute inset-0 pointer-events-none" viewBox="0 0 100 100" width={size} height={size} preserveAspectRatio="none" aria-hidden>
      {Array.from({ length: 12 }).map((_, i) => (
        <line key={i} x1={6 + i * 8} y1="2" x2={4 + i * 8} y2="10" stroke="#93b6d1" strokeWidth="0.8" strokeLinecap="round" opacity="0.55">
          <animate attributeName="y1" values="0;100" dur={`${0.8 + (i % 4) * 0.2}s`} repeatCount="indefinite" begin={`${(i % 5) * 0.12}s`} />
          <animate attributeName="y2" values="8;108" dur={`${0.8 + (i % 4) * 0.2}s`} repeatCount="indefinite" begin={`${(i % 5) * 0.12}s`} />
        </line>
      ))}
    </svg>
  );
}

export default function TreeVisual({ stage = 1, season = "vara", size = 260, weather = "calm", showBird = true, simple = false, vector = false }) {
  const { site } = useSite();
  // vector: forțează desenul SVG (scenele compuse — ex. Plimbarea — au nevoie de fundal transparent)
  const url = vector ? "" : treeImageUrl(site, stage);
  if (url) {
    return (
      <div className="relative inline-block" style={{ width: size, height: size }} data-testid="tree-image">
        <img
          src={url}
          alt={`Copac — stadiul ${stage}`}
          loading={simple ? "lazy" : "eager"}
          style={{ width: size, height: size, objectFit: "contain", display: "block" }}
          className={weather === "wind" || weather === "storm" ? "tree-sway" : ""}
        />
        {weather === "storm" && <RainOverlay size={size} />}
      </div>
    );
  }
  return <TreeSvg stage={stage} season={season} size={size} weather={weather} showBird={showBird} simple={simple} bare={vector} />;
}
